import { useState, useEffect } from "react";
import "./style.css";
import ResponsivePagination from "react-responsive-pagination";

export const PageFilter = ({
  title,
  onClick,
  onChange,
  totalRows,
  page,
  handlePageChange,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm) {
        onChange(searchTerm);
      }
    }, 500); // Adjust delay as needed (e.g., 500ms)

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, onChange]);

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 gap-3">
      {title && (
        <button className="create-btn w-md-auto col-md-2" onClick={onClick}>
          <span>{title}</span>
        </button>
      )}
      <div className="search-wrapper w-100 w-md-auto">
        <div className="search-bar d-flex align-items-center">
          <i className="bi bi-search"></i>
          <input
            type="text"
            className="form-control border-0"
            placeholder="Search..."
            onChange={(e) => setSearchTerm(e)}
          />
        </div>
      </div>
      <div className="w-100 w-md-auto">
        <ResponsivePagination
          total={Math.ceil(totalRows / 12)}
          current={page}
          onPageChange={(page) => handlePageChange(page)}
        />
      </div>
    </div>
  );
};
